import React, { useState, useEffect, useCallback } from 'react';
import { Grid, makeStyles, Typography } from "@material-ui/core";
import { Formik } from 'formik';
import DadosCadastroLote from './DadosCadastroLote';
import { useForm } from '../customHooks';
import DadosLotesManager from "../DadosLotesManager";
import { useHistory } from 'react-router-dom';
import { SECONDARY_COLOR } from "../../../theme";
import { formatarCodigoLote } from '../../../shared/utils/Formatacao';
import ContainerPagina from "../../../shared/components/ContainerPagina";
import { codigoTipoLoteNormal } from '../../../shared/utils/Constantes';
import { connect } from 'react-redux';
import { codigoDGK, codigoDLE, codigoToxicologia, codigoDGKPSC } from "../../../shared/utils/Constantes";
import { dadosAcesso } from '../../login/LoginManager'

const CadastroLotes = ({
    handleEndInsertion,
    editandoCriacao,
    dadosLote,
    editando, tipoCliente
}) => {

    const classes = useStyles();
    const history = useHistory();

    const [disableConservacoes, setDisableConservacoes] = useState(false);
    const [empresas, setEmpresas] = useState([]);
    const [defaultEmpresa, setDefaultEmpresa] = useState("");
    const [disableEmpresas, setDisableEmpresas] = useState(false);
    const [tiposLote, setTiposLote] = useState([]);
    const [tiposConservacaoLote, setTiposConservacaoLote] = useState([]);
    const [idTipoLoteSelecionado, setIdTipoLoteSelecionado] = useState(dadosLote?.tipoLote?.id);
    const [clearTipoLote, setClearTipoLote] = useState(false);
    const [clearTipoConservacaoLote, setClearTipoConservacaoLote] = useState(false);
    const [defaultConservacao, setDefaultConservacao] = useState();
    const [carregando, setCarregando] = useState(false);
    const [possuiImpressora, setPossuiImpressora] = useState(editando ? dadosLote.etiquetaGeradaOnboarding : null);
    const [clienteDGKPSC, setclienteDGKPSC] = useState(false);

    const {
        validationSchema,
        initialValues, 
        initialErrors,
    } = useForm(possuiImpressora);

    useEffect(() =>{
        if(dadosAcesso?.laboratorio?.captacao === codigoDGKPSC) {
            setclienteDGKPSC(true)
        }
    }, []);

    const listarEmpresas = useCallback(async () => {
        const empresas = await DadosLotesManager.listarEmpresas();

        if (empresas && empresas.length > 0) {
            setEmpresas(empresas);

            if (tipoCliente === codigoDGK ||  
                tipoCliente === codigoDLE ||
                tipoCliente === codigoToxicologia) {
    
                setDefaultEmpresa(tipoCliente);
                setDisableEmpresas(true);
            }

            if (clienteDGKPSC) {
                setDefaultEmpresa(codigoDGK);
                setDisableEmpresas(true);
            }
        } else {
            history.goBack();
        }

    }, [history, tipoCliente, clienteDGKPSC]);

    const listarTiposLote = useCallback(async () => {
        const tipos = await DadosLotesManager.listarTiposLote();

        if (tipos && tipos.length > 0) {
            const tipoContidoNaLista = tipos.find(t => t.id === dadosLote?.tipoLote?.id);
            const tipoLoteNormal = tipos.find(t => t.codigo === codigoTipoLoteNormal);

            if (dadosLote?.tipoLote && !tipoContidoNaLista)
                tipos.push(dadosLote.tipoLote);

            tipos.sort((a, b) => a.descricao.localeCompare(b.descricao));

            tipos.splice(tipos.indexOf(tipoLoteNormal), 1);

            tipos.unshift(tipoLoteNormal);

            setTiposLote(tipos);
        } else {
            history.goBack();
        }
    }, [history, dadosLote]);

    const listarTiposConservacaoLote = useCallback(async (TipoLoteSelecionado) => {
        const response = await DadosLotesManager.listarTiposConservacaoLote(TipoLoteSelecionado);
        if (response && response.length > 0) {
            if (response.length === 1) {
                setDisableConservacoes(true);
                setTiposConservacaoLote(response.sort((a, b) => a.descricao.localeCompare(b.descricao)));
                setDefaultConservacao(response[0].codigo);

            }
            else {
                setClearTipoConservacaoLote(true);
                setTiposConservacaoLote(response.sort((a, b) => a.descricao.localeCompare(b.descricao)));
            }
        }
        else {
            setIdTipoLoteSelecionado(null);
            setClearTipoLote(true);
            setClearTipoConservacaoLote(true);
        }
    }, []);

    useEffect(() => {
        if (idTipoLoteSelecionado) {
            setDisableConservacoes(false);
        }
        else {
            setDisableConservacoes(true);
        }

        listarEmpresas();
        listarTiposLote();
        listarTiposConservacaoLote(idTipoLoteSelecionado);

        setClearTipoLote(false);
        setClearTipoConservacaoLote(false);
    }, [idTipoLoteSelecionado, listarTiposLote, listarTiposConservacaoLote, listarEmpresas]);

    const limparFormulario = (formikResetFunc) => {
        formikResetFunc();
    }

    const handleChangePossuiImpressora = (value) => {
        setPossuiImpressora(value);
        setClearTipoLote(true);
        setClearTipoConservacaoLote(true);
    }

    const handleGoBack = async () => {
        history.goBack();
    }

    const gravaTemp = (temp) => {
        if (temp === '')
            return null;

        if (typeof(temp) === 'string') { // Necessário para correção de um bug no IE11
            var num = Number.parseFloat(temp.replace(/,/, '.'));
            return isNaN(num)? null: num;                
        }

        if (isNaN(temp))
            return null;

        return temp;
    }

    const handleSubmit = async (dados, formikResetFunc) => {
        const tipoLote = tiposLote.find((tipo) => tipo.codigo === dados.tipoLote);
        const tipoConservacao = tiposConservacaoLote.find((tipo) => tipo.codigo === dados.tipoConservacaoLote);

        dados = {
            id: dadosLote?.id,
            codigo: dados.numeroEtiqueta,
            tipoLote: {
                id: tipoLote?.id,
                codigo: tipoLote?.codigo
            },
            tipoConservacao: {
                id: tipoConservacao?.id,
                codigo: tipoConservacao?.codigo
            },
            temperatura: gravaTemp(dados.temperatura),
            empresa: empresas.find((empresa) => empresa.codigo === dados.empresa)
        }
        setCarregando(true);

        if (editando || editandoCriacao) {
            const response = await DadosLotesManager.editarLote(dados);

            if (response) {
                dados.tipoLote.descricao = tipoLote.descricao;
                dados.tipoConservacao.descricao = tipoConservacao.descricao;
                dados.etiquetaGeradaOnboarding = possuiImpressora;

                handleEndInsertion(dados);
            }
        }
        else {
            const response = await DadosLotesManager.cadastrarLote(dados);

            if (response) {
                limparFormulario(formikResetFunc);

                dados.id = response.id;
                dados.codigo = response.codigo;
                dados.tipoLote.descricao = tipoLote.descricao;
                dados.tipoConservacao.descricao = tipoConservacao.descricao;
                dados.etiquetaGeradaOnboarding = possuiImpressora;

                handleEndInsertion(dados);
            }
        }

        setCarregando(false);
    }

    return (
        <ContainerPagina>
            <Grid container>
                <Grid item xs={12}>
                    {editando ?
                        <Typography variant="h2" className={classes.titulo}>
                            <span className={classes.editando}>
                                Editando
                                </span>
                                lote {formatarCodigoLote(dadosLote.codigo)}
                        </Typography> :
                        <Typography variant="h2" className={classes.titulo}>
                            Novo lote
                            </Typography>
                    }
                </Grid>
                <Grid item xs={12}>
                    <Formik
                        validationSchema={validationSchema}
                        onSubmit={(dados, { resetForm }) => handleSubmit(dados, resetForm)}
                        initialValues={initialValues}
                        initialErrors={initialErrors}
                        enableReinitialize
                    >
                        {({ handleSubmit, isValid, dirty }) => (
                            <DadosCadastroLote
                                handleSubmit={handleSubmit}
                                handleGoBack={handleGoBack}
                                empresaSelecionada={editando ? dadosLote.empresa?.codigo ?? "": ""}
                                empresas={empresas}
                                defaultEmpresa={defaultEmpresa}
                                disableEmpresas={disableEmpresas}
                                disableConservacoes={disableConservacoes}
                                tiposLote={tiposLote}
                                tiposConservacaoLote={tiposConservacaoLote}
                                isValid={isValid && dirty}
                                carregando={carregando}
                                setIdTipoLoteSelecionado={setIdTipoLoteSelecionado}
                                clearTipoLote={clearTipoLote}
                                clearTipoConservacaoLote={clearTipoConservacaoLote}
                                defaultConservacao={defaultConservacao}
                                setDefaultConservacao={setDefaultConservacao}
                                editando={editando}
                                numeroEtiqueta={editando ? formatarCodigoLote(dadosLote.codigo) : dadosLote.codigo}
                                codigoTipoLote={dadosLote.tipoLote?.codigo}
                                codigoTipoConservacao={dadosLote.tipoConservacao?.codigo}
                                temperatura={dadosLote.temperatura}
                                possuiImpressora={possuiImpressora}
                                handleChangePossuiImpressora={handleChangePossuiImpressora}
                            />
                        )}
                    </Formik>
                </Grid>
            </Grid>
        </ContainerPagina>
    );
}

const useStyles = makeStyles((theme) => ({
    titulo: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(3),
    },
    editando: {
        color: SECONDARY_COLOR,
        paddingRight: "6px"
    }
}))

export default connect(
    (state) => {
        return {
            tipoCliente: state.login.laboratorio.tipoCliente.codigo
        }
    },
    null
)(CadastroLotes);
